export default function ContactUs() {
     return(
          <section className = "contact-section">
               <h2 className = "contact-title"> 
               Get In Touch</h2>
               <p className = "contact-text">
               We'd love to hear from you! Whether it's a question, quote or compliment—reach out any time.
               </p>
               <a href = "mailto:alivegardens24@gmail.com" className = "contact-email">
                    ALIVEGARDENS24@GMAIL.COM
               </a>
               <div className = "social-links">
                    <p>
                    🌿 Check us out{' '}
                    <a href = "https://www.instagram.com/alivegardens23/"
                     target="_blank"
                     rel="noopener noreferrer"
                     className="contact-link">
                         Instagram
                     </a>
                    </p>
               </div>
          </section>
     );
}